import { GAGoalsFeaturesDataMapping } from '../constants'

export type GAGoalsFeaturesDataType = keyof typeof GAGoalsFeaturesDataMapping

export enum LockEventName {
  CTA_CLICKED = 'cta_clicked',
  LOCK_VIEW = 'lock_view',
}
